
function getWishlist() {
    return JSON.parse(localStorage.getItem('user_wishlist')) || [];
}

function saveWishlist(data) {
    localStorage.setItem('user_wishlist', JSON.stringify(data));
}

function updateWishlistBadge() {
    const badge = document.getElementById('wishlist-count-badge');
    if (!badge) return;

    const wishlist = getWishlist();
    const count = wishlist.length;

    if (count > 0) {
        badge.textContent = count;
        badge.style.display = 'flex';
    } else {
        badge.style.display = 'none';
    }
}


function syncWishlistIcons() {
    let wishlist = getWishlist();
    $('.js-wishlist, .wishlist-icon').each(function () {
        const handle = $(this).data('handle') || $(this).data('product-handle');
        if (wishlist.some(item => item.handle === handle)) {
            $(this).addClass('active');
        } else {
            $(this).removeClass('active');
        }
    });
}

$(document).ready(function() {
    syncWishlistIcons();
    $(document).on('click', '.js-wishlist', function (e) {
    e.preventDefault();
            if (!window.customerData.isLoggedIn) {
                openLoginModal(); 
                return;
            }
            const $btn = $(this);
            const productData = {
                handle: $btn.data('handle'),
                title: $btn.data('title'),
                price: parseInt($btn.data('price')),
                compare_price: $btn.data('compare-price'),
                image: $btn.data('image'),
                badge: $btn.data('badge') || '',
                variant_id: $btn.data('variant'),
                hover_image: $btn.data('hover-image') || $btn.closest('.product-card').find('.prodx-slide img').eq(1).attr('src'),
                description: $btn.data('description') || $btn.closest('.product-card').find('.product-desc').text().trim(),
                flags: $btn.attr('data-flags') || $btn.closest('.product-card').find('.flag-icons-group').html()
            };

            let wishlist = getWishlist();
            const index = wishlist.findIndex(item => item.handle === productData.handle);

            if (index > -1) {
                wishlist.splice(index, 1);
                $btn.removeClass('active');
                if (typeof showToast === "function") showToast('Removed from wishlist', 'error');
            } else {
                wishlist.push(productData);
                $btn.addClass('active');
                if (typeof createFloatingHearts === "function") createFloatingHearts(this);
                if (typeof showToast === "function") showToast('Added to wishlist!', 'success');
            }

            saveWishlist(wishlist);
            updateWishlistBadge();
            syncWishlistToAccount(wishlist);
        });
});

function syncWishlistToAccount(wishlist) {
    const handles = wishlist.map(item => item.handle).join(',');
    fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            attributes: {
                'customer_wishlist': handles
            }
        })
    })
    .then(res => res.json())
    .then(data => {
        console.log("SUCCESS: Wishlist saved to Shopify Cart Session!", data.attributes);
    })
    .catch(err => console.error("Sync failed:", err));
}


window.openLoginModal = function() {
    const modal = document.getElementById('login-modal');
    if (modal) {
        modal.style.display = 'flex';

        setTimeout(() => {
            modal.classList.add('active');
        }, 10);

        document.body.style.overflow = 'hidden';
    }
};

window.closeLoginModal = function() {
    const modal = document.getElementById('login-modal');
    if (modal) {
        modal.classList.remove('active');
        setTimeout(() => {
            modal.style.display = 'none';
        }, 500);

        document.body.style.overflow = 'auto';
    }
};
